import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeyCloakCustomService } from '../../keycloak/services/key-cloak-custom-service';
import { JoetStoreService } from '../../shared/services/joet-store.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const keyCloakService = inject(KeyCloakCustomService);
    const joetStoreService = inject(JoetStoreService);
    const router = inject(Router);

    // check if user is logged in
    if (keyCloakService.isLoggedIn()) {
        if (joetStoreService.userBaseInfoForClaims()) {
            return true;
        } else {
            await joetStoreService.fetchUserClaim();
            return true;
        }
    } else {
        // redirect to login, preserve return URL
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
